import React from 'react';
import '../css/SSIDsDetails.css'; // 导入样式文件
import { fetchWifiData } from '../data/getdata';
import wifiIcon from '../svg/wifi.svg';
import backIcon from '../svg/back.svg'; // 导入back.svg图标
import APsIcon from '../svg/Aps.svg';
import BSSIDsIcon from '../svg/BSSIDs.svg';
import ChannelIcon from '../svg/mu-ch.svg';
import ClientIcon from '../svg/client.svg';
import moreIcon from '../svg/more.svg';

const SSIDsDetails = ({ selectedSSID, otherData, onReturn }) => {
  // 打印选中的SSID的详细信息
  console.log(selectedSSID);
  
  // 获取选中的SSID的详细信息
  const {
    hidden_state,
    ssid,
    strongestApName,
    signal,
    snr,
    wifi_item: {
      wlan_protocol_set,
      security_type_set,
      last_seen
    }
  } = selectedSSID;

  // 根据hidden_state的值确定Wi-Fi状态显示内容
  const wifiStatus = hidden_state === 'NOT_HIDDEN' ? '广播SSID' : '隐藏SSID';

  // 根据wlan_protocol_set的值确定Wi-Fi支持的协议
  let wifiProtocol = '';
  const protocolMap = {
    128: 'ax',
    32: 'ac',
    16: 'n',
    8: 'g',
    4: 'a',
    2: 'b',
  };
  const protocolOrder = [128, 32, 16, 8, 4, 2];
  
  for (let key of protocolOrder) {
    if (wlan_protocol_set.includes(key)) {
      wifiProtocol += protocolMap[key] + ', ';
    }
  }
  // 移除末尾的逗号和空格
  wifiProtocol = wifiProtocol.trim().replace(/,\s*$/, '');
  
  // 根据securityType的值确定安全类型
  let securityType = '';
  const securityMap = {
    1: 'OPEN',
    8: 'WPA-P',
    32: 'WPA2-P',
    2048: 'WPA3-P',
  };
  
  Object.entries(securityMap)
    .sort(([keyA], [keyB]) => parseInt(keyB) - parseInt(keyA))
    .forEach(([key, value]) => {
      if (security_type_set.includes(parseInt(key))) {
        securityType += value + ', ';
      }
    });
  
  // 移除末尾的逗号和空格
  securityType = securityType.trim().replace(/,\s*$/, '');
  

  // 将时间戳转换为格式化的上午/下午时间字符串
  const formatLastSeenTime = (timestamp) => {
    const date = new Date(timestamp);
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    const ampm = hours >= 12 ? '下午' : '上午';
    hours = hours % 12;
    hours = hours ? hours : 12; // 如果是0，则显示12
    const formattedTime = ampm + ' ' + hours + ':' + minutes + ':' + seconds;
    return formattedTime;
  };

  //--------------------根据ID获取匹配的APs列表--------------------
  const getMatchedAPs = (selectedSSID, otherData) => {
    // 确保 selectedSSID 和 otherData 都存在
    if (!selectedSSID || !selectedSSID.wifi_item || !selectedSSID.wifi_item.aps || !otherData || !otherData.aps) return [];
  
    // 获取当前SSID的APs列表
    const aps = selectedSSID.wifi_item.aps;
  
    // 遍历所有APs并与otherData中的匹配
    const matchedAPs = aps.filter(ap => otherData.aps.find(item => item.wifi_item.id === ap));
  
    // 返回匹配的AP的名称列表
    return matchedAPs.map(ap => otherData.aps.find(item => item.wifi_item.id === ap)?.wifi_host.best_name_formatted).filter(Boolean);
  };
  //--------------------根据ID获取匹配的BSSIDs列表--------------------
const getMatchedBSSIDs = (selectedSSID, otherData) => {
  // 确保 selectedSSID 和 otherData 都存在
  if (!selectedSSID || !selectedSSID.wifi_item || !selectedSSID.wifi_item.bssids || !otherData || !otherData.bssids) return [];
  
  // 获取当前SSID的BSSIDs列表
  const bssids = selectedSSID.wifi_item.bssids;
  
  // 遍历所有BSSIDs并与otherData中的匹配
  const matchedBSSIDs = bssids.filter(bssid => otherData.bssids.find(item => item.wifi_item.id === bssid));
  
  // 返回匹配的BSSID的名称列表
  return matchedBSSIDs.map(bssid => otherData.bssids.find(item => item.wifi_item.id === bssid)?.wifi_host.best_name_formatted).filter(Boolean);
};

//--------------------根据ID获取匹配的客户端列表--------------------
const getMatchedClients = (selectedSSID, otherData) => {
  // 确保 selectedSSID 和 otherData 都存在
  if (!selectedSSID || !selectedSSID.wifi_item || !selectedSSID.wifi_item.clients || !otherData || !otherData.clients) return [];
  
  // 获取当前SSID的客户端列表
  const clients = selectedSSID.wifi_item.clients;
  
  // 遍历所有客户端并与 otherData 中的匹配
  const matchedClients = clients.filter(client => otherData.clients.find(item => item.wifi_item.id === client));
  
  // 返回匹配的客户端列表
  return matchedClients.map(client => otherData.clients.find(item => item.wifi_item.id === client)?.wifi_host.best_name_formatted).filter(Boolean);
};

    // 获取匹配的APs列表
    const selectedmatchedAPs = getMatchedAPs(selectedSSID, otherData);
    console.log(selectedmatchedAPs);

    // 获取匹配的BSSIDs列表
    const selectematchedBSSIDs = getMatchedBSSIDs(selectedSSID, otherData);
    console.log(selectematchedBSSIDs);

    // 获取匹配的客户端列表
    const selectematchedClients = getMatchedClients(selectedSSID, otherData);
    console.log(selectematchedClients);




  return (
    <div className="ssid-details">
    <div className="ssid-details-container">
      <img src={wifiIcon} alt="WiFi Logo" className="wifi-icon" />
      <div className="SSID1">{ssid !== '' ? ssid : '[Hidden]'}</div>
      <div className="wifiStatus">{wifiStatus}</div>
      <div className="SSID2">{ssid !== '' ? ssid : '[Hidden]'}</div>
      <div className="details">类型: {wifiProtocol}</div>
      <div className="details">安全类型: {securityType}</div>
      <div className="details">信号最强AP: <span className="strongestApName">{strongestApName}</span></div>      <div className="details">信号: {signal} dBm</div>
      <div className="formatLastSeenTime">上次看到: {formatLastSeenTime(last_seen)}</div>
      <img className="back-button" src={backIcon} alt="Back" onClick={onReturn} />
      </div>


      <div className="additional-details-box">
        <img src={APsIcon} alt="APs Logo" className="wifi-icon" />
        <img src={moreIcon} alt="More" className="more-icon" />
        <div className="Title">APs</div>
        <div className="count">{selectedSSID.wifi_item.aps ? selectedSSID.wifi_item.aps.length : 0}</div>
        <div className="selectematched">{selectedmatchedAPs &&  selectedmatchedAPs.join(', ') }</div>
      </div>

      <div className="additional-details-box">
        <img src={BSSIDsIcon} alt="BSSIDs Logo" className="wifi-icon" />
        <img src={moreIcon} alt="More" className="more-icon" />
        <div className="Title">BSSIDs</div>
        <div className="count">{selectedSSID.wifi_item.bssids ? selectedSSID.wifi_item.bssids.length : 0}</div>
        <div className="selectematched">{selectematchedBSSIDs &&  selectematchedBSSIDs.join(', ') }</div>
      </div>

      <div className="additional-details-box">
        <img src={ChannelIcon} alt="Channel Logo" className="wifi-icon" />
        <img src={moreIcon} alt="More" className="more-icon" />
        <div className="Title">信道</div>
        <div className="count">{selectedSSID.wifi_item.airwise_active_channels ? selectedSSID.wifi_item.airwise_active_channels.length :0 }</div>
        <div className="selectematched">{selectedSSID.wifi_item.airwise_active_channels &&  selectedSSID.wifi_item.airwise_active_channels.join(', ') }</div>
      </div>

      <div className="additional-details-box-clients">
        <img src={ClientIcon} alt="Client Logo" className="wifi-icon" />
        <img src={moreIcon} alt="More-clients" className="more-icon-clients" />
        <div className="Title-clients">客户端</div>
        <div className="count-clients">{selectedSSID.wifi_item.clients ? selectedSSID.wifi_item.clients.length : 0}</div>
      </div>

    </div>
      

  );
};

export default SSIDsDetails;
